import { render, staticRenderFns } from "./thirty-details.vue?vue&type=template&id=1c061e63&"
import script from "./thirty-details.vue?vue&type=script&lang=js&"
export * from "./thirty-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports